import PageContainer from '@/common/components/PageContainer'
import NavigateBackButton from '@/common/components/NavigateBackButton'
import Spinner from '@/common/components/Spinner'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useParams, useNavigate } from 'react-router-dom'
import { Button } from '@/common/ui/button'
import useQueryGetLineMessageLogById from '../../api/hooks/useQueryGetLineMessageLogById'
import useQueryGetLineMessageLogGrouped from '../../api/hooks/useQueryGetLineMessageLogGrouped'
import LineMessageLogDetail from '../../components/LineMessageLogDetail'
import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'

function LineMessageLogDetailPage() {
	const { id } = useParams<{ id: string }>()
	const navigate = useNavigate()

	// Fetch the log details by ID
	const { data: log, isLoading: isLogLoading } = useQueryGetLineMessageLogById(
		id || '',
	)

	// Fetch grouped messages for this log
	const { data: groupedData, isLoading: isGroupedLoading } =
		useQueryGetLineMessageLogGrouped(id || '', { enabled: !!id })

	if (isLogLoading) {
		return (
			<PageContainer>
				<div className="flex h-96 items-center justify-center">
					<Spinner />
				</div>
			</PageContainer>
		)
	}

	if (!log) {
		return (
			<PageContainer>
				<div className="flex h-96 flex-col items-center justify-center space-y-4">
					<h1 className="text-2xl font-bold">ไม่พบข้อมูล Log</h1>
					<p className="text-muted-foreground">
						Log ที่คุณต้องการดูไม่พบในระบบ
					</p>
					<Button onClick={() => navigate('/operator/line-message-log')}>
						กลับไปหน้ารายการ
					</Button>
				</div>
			</PageContainer>
		)
	}

	return (
		<PageContainer>
			<div className="space-y-4">
				<NavigateBackButton />
				<Heading
					title="รายละเอียด LINE Message Log"
					description="ข้อมูลรายละเอียดการส่งข้อความ LINE"
				/>
				<Separator />
				<LineMessageLogDetail
					log={log}
					groupedMessages={groupedData?.messages || []}
					totalMessages={groupedData?.totalMessages || 0}
					totalChatRooms={groupedData?.totalChatRooms || 0}
					chatRoomIds={groupedData?.chatRoomIds || []}
					isLoading={isGroupedLoading}
				/>
			</div>
		</PageContainer>
	)
}

const GuardedLineMessageLogDetailPage = withUserPermission(
	LineMessageLogDetailPage,
	{
		permissionType: PermissionType.Read,
		permissionKey: [PermissionKeys.MANAGE_CHAT],
	},
)

export default GuardedLineMessageLogDetailPage
